import { Typography } from 'antd';
import { SelectInput } from 'components/UI/FormItems/SelectInput';
import { useConfigTypes } from 'hooks/useConfigTypes';
import { AssignedProductsFormLabels } from 'models/UpdateProductCatalog';
import React, { FC } from 'react';

interface Props {
  hideLabel?: boolean;
  isInheritanceBusiness: boolean;
}

export const ConfigTypeInput: FC<Props> = ({ hideLabel, isInheritanceBusiness }) => {
  /* ******************** Hooks ******************** */
  const { options, isLoading, isError, errorMessage } = useConfigTypes();

  /* ******************** Variables ******************** */
  // When the list cannot be loaded the select is emptied and locked rather than falling back to a
  // list compiled into the app: a code D365 no longer knows would be rejected at sales order submit.
  const isDisabled = isInheritanceBusiness || isError;

  return (
    <>
      <SelectInput fieldName="defaultConfigType" label={hideLabel ? undefined : AssignedProductsFormLabels.defaultConfigType} options={options} loading={isLoading} disabled={isDisabled} allowClear />
      {isError && <Typography.Text type="danger">{errorMessage}</Typography.Text>}
    </>
  );
};
